import * as React from 'react';
import { Cross } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { CONTAINER_SIZES } from '../../../constants/sizes.js';
import { Icon } from '../../Icon/src/Icon.js';
import modules_1e09d314 from '../styles/Tag.module.less.js';

/**
 * @description Tag for categorizing or markup
 *
 * @component
 * @example
 * ```jsx
 * <Tag>content</Tag>
 * ```
 */
const Tag = React.forwardRef((props, ref) => {
    const { size = CONTAINER_SIZES.S44, active, closable, onClose, className, children, ...restProps } = props;
    const cx = useStyles(modules_1e09d314);
    const classNames = cx(className, 'container', {
        active,
        [`size-${size}`]: size,
    });
    return (React.createElement("span", { ref: ref, "data-qa": "Tag", className: classNames, ...restProps },
        children,
        closable ? React.createElement(Icon, { icon: React.createElement(Cross, null), onClick: onClose }) : null));
});
Tag.displayName = 'Tag';

export { Tag };
//# sourceMappingURL=Tag.js.map
